import { defineComponent, h, PropType } from 'vue';
import { State } from '../../state';
import { as } from '@phi/util/types';
import BarButton from '@components/bar-button';
import { coming_soon } from '@components/icons';
import info_svg from '../../../assets/img/SVG_icons/Left/help/help.svg';
import { img } from '@phi/components';
import InfoTooltip from './InfoTooltip';

export default defineComponent({
    props: {
        loaded: {
            required: true,
            type: Boolean,
        },

        aside: {
            required: true,
            type: as<PropType<State['aside']>>(null),
        },

        is_demo: {
            required: true,
            type: Boolean,
        },
    },

    computed: {
        coming_soon() {
            return !this.loaded;
        },

        alt() {
            return 'Show / hide sidebar';
        },
    },

    emits: {
        'update:aside': (x: State['aside']) => true,
    },

    data() {
        return {
            previous: as<State['aside']>(undefined),
        };
    },

    methods: {
        onClick() {
            if (!this.loaded) return false;
            else if (this.aside)
                this.$emit('update:aside', undefined);
            else if (this.previous)
                this.$emit('update:aside', this.previous);
            else if (this.is_demo)
                this.$emit('update:aside', 'tutorials');
            else
                this.$emit('update:aside', 'intro');
        },
    },

    watch: {
        aside(value: typeof this.aside, oldValue: typeof this.aside) {
            if (value === undefined && oldValue)
                this.previous = oldValue;
        }
    },

    render() {
        return h(BarButton, {
            id: 'info-button',
            active: this.aside !== undefined,
            tippy: 'left',
            onClick: this.onClick,
            disabled: !this.loaded,
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(info_svg, this.alt),
            tooltip: InfoTooltip,
        });
    },
});
